import { useQuery } from '@tanstack/react-query'
import { fetchLeaders } from '../../fetch'
import { UseLeadersQueryParams } from '../../fetch/types'

export const useLeadersQuery = (params: UseLeadersQueryParams) => {
  return useQuery(
    ['leaders', params.copytradingLeadersParams],
    async () => {
      return await fetchLeaders(params.copytradingLeadersParams)
    },
    { staleTime: Infinity, ...params.options }
  )
}
